import { render, staticRenderFns } from "./SearchTermsHelperTable.vue?vue&type=template&id=676f5a06&scoped=true&"
import script from "./SearchTermsHelperTable.vue?vue&type=script&lang=js&"
export * from "./SearchTermsHelperTable.vue?vue&type=script&lang=js&"
import style0 from "./SearchTermsHelperTable.vue?vue&type=style&index=0&id=676f5a06&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676f5a06",
  null
  
)

export default component.exports